@switch (true) {

@case(!pdpService.selectedArea()){
<div class="stock-wrapper other-store">

  <div class="stock-row title">
    <span>{{"AREAS"|translate}}</span>
  </div>

  @if(!pdpService.globalAreasStock() && !pdpService.globalAreasBatchStock()){

  <app-placeholder [message]="'No company available' | translate"></app-placeholder>

  }@else {

  @if(pdpService.globalAreasStock()){
  <div class="stores placeholder-glow">

    @for(area of pdpService.globalAreasStock(); let i = $index; track $index) {
    <button class="btn btn-secondary area" (click)="handleSelectArea(area, $index)">
      <span>{{area.description}}</span>
      <span>
        <!-- @if(area.countCompanies > 0){
        ({{area.countCompanies}})
        } -->
        <i class="bi bi-chevron-right"></i>
      </span>
    </button>

    }

  </div>
  }

  @if(pdpService.globalAreasBatchStock()){
  <div class="stores placeholder-glow">

    @for(area of pdpService.globalAreasBatchStock(); let i = $index; track $index) {
    <button class="btn btn-secondary area" (click)="handleSelectArea(area, $index)">
      <span>{{area.description}}</span>
      <span>
        <!-- @if(area.countCompanies > 0){
        ({{area.countCompanies}})
        } -->
        <i class="bi bi-chevron-right"></i>
      </span>
    </button>

    }

  </div>
  }

  }

</div>

}

@case(!!pdpService.selectedArea() && !isBatchManaged(pdpService.selectedArea()!)){
<app-hq-stock [hqStock]="selectedCompaniesWithStock()" [sapCode]="sapCode"
  [selectedArea]="pdpService.selectedArea()!.description"
  (handleGoBackToAreaList)="handleSelectArea(null, -1)"></app-hq-stock>
}

@case(!!pdpService.selectedArea() && isBatchManaged(pdpService.selectedArea()!)){
<app-hq-batch-stock [hqBatchStock]="selectedCompaniesWithBatchStock()" [sapCode]="sapCode"
  [selectedArea]="pdpService.selectedArea()!.description"
  (handleGoBackToAreaList)="handleSelectArea(null, -1)"></app-hq-batch-stock>
}

}
